// TODO: In order to reduce bundle size we should import only the icons we use, move this import and ADOBE_ICON_MAP to another file to ease readability
import * as muiIcon from '@ally/metronome-icons'

interface NameValuePairObj {
  [key: string]: muiIcon.MuiIconMap
}

export const SERVER_TIMEZONE = 'America/New_York'

export const ADOBE_ICON_MAP: NameValuePairObj = {
  add: muiIcon.muiPlus,
  alert: muiIcon.muiWarningFill,
  'ally-a': muiIcon.muiTruthmark,
  'auto-renew': muiIcon.muiRefresh,
  'bank-pig': muiIcon.muiPiggyBank,
  bar: muiIcon.muiMinus,
  'bar-graph': muiIcon.muiBarChart,
  bell: muiIcon.muiNotification,
  burger: muiIcon.muiMenu,
  calendar: muiIcon.muiCalendar,
  cancel: muiIcon.muiX,
  'car-front': muiIcon.muiAuto,
  carrot: muiIcon.muiChevronDown,
  'cash-envelope-outline': muiIcon.muiMailBill,
  chat: muiIcon.muiChatFill,
  'chat-icon': muiIcon.muiChatOutline,
  check: muiIcon.muiCheckMark,
  'circle-check': muiIcon.muiSuccessFill,
  'circle-check-hollow': muiIcon.muiSuccessOutline,
  'circle-dollarlog': muiIcon.muiDollarOutline,
  'circle-exclaim': muiIcon.muiErrorFill,
  'circle-exclaim-unfilled': muiIcon.muiErrorOutline,
  'circle-percent': muiIcon.muiPercentOutline,
  'circle-questionmark': muiIcon.muiHelpOutline,
  'circling-arrows-outline': muiIcon.muiTransfers,
  clock: muiIcon.muiClock,
  'credit-card': muiIcon.muiCreditCard,
  'darrow-solid': muiIcon.muiCaretDown,
  doc: muiIcon.muiPage,
  doccheck: muiIcon.muiPageCheck,
  donut: muiIcon.muiSegmentedCircle,
  'donut-flipped': muiIcon.muiSegmentedCircle,
  'email-outline': muiIcon.muiMailClosed,
  'equal-housing-lender': muiIcon.muiEqualHousing,
  facebook: muiIcon.muiFacebook,
  'google-plus-plain': muiIcon.muiGooglePlus,
  'home-outline': muiIcon.muiHouseOutline,
  'info-fill': muiIcon.muiInfoFill,
  information: muiIcon.muiInfoFill,
  iphone: muiIcon.muiMobilePhone,
  laptop: muiIcon.muiLaptop,
  'larrow-solid': muiIcon.muiCaretLeft,
  lightbulb: muiIcon.muiLightbulb,
  'line-chart': muiIcon.muiLineChart,
  'line-graph': muiIcon.muiLineChart,
  link: muiIcon.muiLink,
  'link-flipped': muiIcon.muiLink,
  'linked-in': muiIcon.muiLinkedIn,
  list: muiIcon.muiList,
  lock: muiIcon.muiLockOutline,
  magnify: muiIcon.muiSearch,
  mail: muiIcon.muiMailClosed,
  mailbox: muiIcon.muiSnailMail,
  'map-locate': muiIcon.muiMapPinFill,
  'map-pin': muiIcon.muiMapPinOutline,
  'member-fdic': muiIcon.muiFDIC,
  'mobile-phone': muiIcon.muiMobilePhone,
  'money-magnify': muiIcon.muiSearchTransaction,
  'money-mail': muiIcon.muiMailBill,
  'money-stack': muiIcon.muiMoneyStack,
  monitor: muiIcon.muiDesktop,
  paper: muiIcon.muiPage,
  'paper-clip': muiIcon.muiAttach,
  pause: muiIcon.muiPause,
  'pause-circle': muiIcon.muiPauseCircleOutline,
  phone: muiIcon.muiPhoneOutline,
  'phone-flipped': muiIcon.muiPhoneFill,
  play: muiIcon.muiPlayFill,
  'play-circle': muiIcon.muiPlayCircleOutline,
  'play-square': muiIcon.muiPlaySquareFill,
  print: muiIcon.muiPrinterFill,
  'rarrow-solid': muiIcon.muiCaretRight,
  rss: muiIcon.muiRSS,
  settings: muiIcon.muiSettings,
  share: muiIcon.muiShare,
  shield: muiIcon.muiShield,
  star: muiIcon.muiStarFill,
  transfer: muiIcon.muiTransfers,
  'twitter-bird': muiIcon.muiTwitter,
  'uarrow-solid': muiIcon.muiCaretUp,
  x: muiIcon.muiX,
  youtube: muiIcon.muiYouTube,
}

export interface ProductIdLookupObj {
  [key: number]: string
}

export const PRODUCT_ID_LOOKUP: ProductIdLookupObj = {
  4102: 'MMA',
  4107: 'OSA',
  4108: 'HYSA',
}

export interface AccountTypeLookupObj {
  [key: string]: string
}

export const INVEST_ACCOUNT_TYPES = ['INVW', 'INVA', 'INVS']

export const INVEST_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  INVW: 'Wealth Management',
  INVA: 'Robo Portfolio',
  INVS: 'Self-Directed',
}

export const BANK_ACCOUNT_TYPES = ['CHECKING', 'SAVINGS', 'CD', 'IRA']

export const BANK_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  CHECKING: 'Interest Checking',
  SAVINGS: 'Savings',
  CD: 'CDs',
  IRA: 'IRAs',
}

export const STALE_DATA_COPY =
  'We can’t update your account information right now, but we’re working on it.'
